module.exports = __webpack_public_path__ + "assets/img/30-s.d378da0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/30-s.jpg
// module id = v3ig
// module chunks = 0